import { z } from 'zod';
import { DrawingStatus } from '../enums';

export { DrawingStatus };

export const DrawingStatusSchema = z.nativeEnum(DrawingStatus);

export type DrawingStatusEnum = z.infer<typeof DrawingStatusSchema>;

export const DrawingSetSchema = z.object({
  id: z.string().uuid(),
  project_id: z.string().uuid(),
  folder_id: z.string().uuid(),
  name: z.string(),
  status: DrawingStatusSchema,
  sort_order: z.number().int(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
  sheet_count: z.number().int().optional(),
  approved_count: z.number().int().optional(),
});

export type DrawingSet = z.infer<typeof DrawingSetSchema>;

export const CreateDrawingSetSchema = z.object({
  name: z.string().min(1),
  folder_id: z.string().uuid(),
});

export type CreateDrawingSet = z.infer<typeof CreateDrawingSetSchema>;

export const UpdateDrawingSetSchema = z.object({
  name: z.string().min(1).optional(),
  sort_order: z.number().int().optional(),
});

export type UpdateDrawingSet = z.infer<typeof UpdateDrawingSetSchema>;
